import { render } from "./IncomesTSModal.vue?vue&type=template&id=1dc5d8e8&scoped=true"
import script from "./IncomesTSModal.vue?vue&type=script&lang=js"
export * from "./IncomesTSModal.vue?vue&type=script&lang=js"

import "./IncomesTSModal.vue?vue&type=style&index=0&id=1dc5d8e8&scoped=true&lang=css"

import exportComponent from "C:\\AgentIFAS\\_work\\52\\s\\Nezivotko.Web2\\CreditWorthiness\\real-world-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dc5d8e8"]])

export default __exports__